import { Component, input } from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";
import { TranslatePipe } from "@ngx-translate/core";
import { KENDO_CHECKBOX, KENDO_TEXTBOX } from "@progress/kendo-angular-inputs";
import { PENALTY_HOURS, PenaltyFactorGroup } from "./penalty-factor-group";
import { ChangedFieldDirective } from "../../changed-field.directive";

@Component({
    selector: "app-penalty-factor-tab",
    imports: [ChangedFieldDirective, ReactiveFormsModule, TranslatePipe, KENDO_TEXTBOX, KENDO_CHECKBOX],
    templateUrl: "./penalty-factor-tab.component.html",
    styleUrl: "../../edit-fields.scss",
})
export class PenaltyFactorTabComponent {
    readonly group = input.required<PenaltyFactorGroup>();

    readonly hours = PENALTY_HOURS;
}
